import {
	Component,
	OnInit,
	Output,
	EventEmitter,
	Optional,
	Input,
	AfterViewInit,
	ElementRef
} from "@angular/core";
import { CtaButtonComponent } from "../cta-button/cta-button.component";
import { CtaButtonGroupControlComponent } from "../cta-button-group-control/cta-button-group-control.component";
// import { SwiperConfigInterface } from "@sonrisa-dev/ngx-swiper-wrapper-sonfork";

@Component({
    selector: "dodo-cta-button-group",
    templateUrl: "./cta-button-group.component.html",
    styleUrls: ["./cta-button-group.component.scss"],
    standalone: false
})
export class CtaButtonGroupComponent implements OnInit, AfterViewInit {
	@Input() showPointer = false;
	@Input() showSwiper: boolean;
	@Input() title: string;
	@Input() hidePointer = false;

	_buttons: CtaButtonComponent[] = [];

	_pointerPosition = -1;
	_totalStops = 0;

	// public config: SwiperConfigInterface = {
	// 	observer: true,
	// 	direction: "horizontal",
	// 	threshold: 0,
	// 	slidesPerView: 2,
	// 	keyboard: true,
	// 	mousewheel: true,
	// 	scrollbar: false,
	// 	navigation: true,
	// 	pagination: false,
	// 	slidesOffsetBefore: 200
	// };

	set activeButtonId(id: string | number) {
		if (this.__activeButtonId !== id) {
			this.__activeButtonId = id;

			if (this._buttons) {
				this.__updateButtonStatus();
			}
		}
	}

	private __activeButtonId: string | number;

	@Output() buttonClicked = new EventEmitter<string | number>();

	constructor(
		private __er: ElementRef,
		@Optional()
		private __buttonsGroupControl: CtaButtonGroupControlComponent
	) {}

	ngOnInit() {
		if (this.__buttonsGroupControl) {
			this.__buttonsGroupControl.registerButtonGroup(this);
		}
	}

	addButton(button: CtaButtonComponent) {
		button.clicked.subscribe((id: string | number) => {
			this.activeButtonId = id;
			this.buttonClicked.emit(this.__activeButtonId);
		});

		button.__active = button.id === this.__activeButtonId;
		this._buttons.push(button);
		this._totalStops = this._buttons.length;
		this.__updatePointerPosition();
	}

	removeButton(button: CtaButtonComponent) {
		const buttonIndex = this._buttons.map(b => b.id).indexOf(button.id);
		this._buttons.splice(buttonIndex, 1);
		if (button.id === this.__activeButtonId) {
			this.__resetActiveButton();
		}
	}

	setPointer(pointerVisibility: "show" | "hide") {
		const val = pointerVisibility === "show";
		this.showPointer = val;
		this._totalStops = this._buttons.length;
	}

	private __resetActiveButton() {
		this.__activeButtonId = undefined;
		this._pointerPosition = -1;
	}

	private __updateButtonStatus() {
		this._buttons.forEach(
			b => (b.__active = b.id === this.__activeButtonId)
		);
		this.__updatePointerPosition();
	}

	private __updatePointerPosition() {
		this._pointerPosition = this._buttons
			.map(b => b.id)
			.indexOf(this.__activeButtonId);
	}

	ngAfterViewInit() {
		setTimeout(() => {
			const width = this.__er.nativeElement.offsetWidth;
			const beforeOffSet = width / 4;
			// this.config["slidesOffsetBefore"] = beforeOffSet;
			// this.config["slidesOffsetAfter"] = beforeOffSet;
		});
	}
}
